import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { CaregiverInvolvementFormValues } from "./interface";

interface EditFieldsProps {
  formValues: CaregiverInvolvementFormValues;
  handleChange: (
    field: keyof CaregiverInvolvementFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledTextArea
        multiline
        label="Involvement"
        value={formValues.involvement}
        onChange={handleChange("involvement")}
        helperText="Indicate which caregiver(s) participate in sessions, what level of support they provide during sessions, and a general summary of your approach to caregiver training."
      />
      <LabeledTextArea
        multiline
        label="Barriers to treatment adherence"
        value={formValues.barriersToTreatmentAdherence}
        onChange={handleChange("barriersToTreatmentAdherence")}
        helperText="List barriers that have hindered progress, such as cancellations, illness, low parental involvement, etc. and if you have a plan in place to address those barriers."
      />
      <LabeledTextArea
        multiline
        label="Barriers to participation"
        value={formValues.barriersToParticipation}
        onChange={handleChange("barriersToParticipation")}
        helperText="Describe any barriers to participation you anticipate at initial assessment or any observed barriers at re-authorization."
      />
      <LabeledTextArea
        multiline
        label="Summary of caregiver participation"
        value={formValues.summaryCaregiverParticipation}
        onChange={handleChange("summaryCaregiverParticipation")}
        helperText="Provide a summary of participation including the frequency of participation and adherence to scheduled caregiver training sessions."
      />
      <LabeledTextArea
        label="Location of caregiver training sessions"
        placeholder="ex. family's home"
        value={formValues.locationTrainingSessions}
        onChange={handleChange("locationTrainingSessions")}
        helperText="Indicate where the caregiver is typically located when participating in caregiver training sessions."
      />
    </Grid>
  );
};

export default EditFields;
